<template>
  <div>
    <van-nav-bar fixed="fixed">
      <template #left>
        <div @click="$back(this)" @dblclick="$backHome(this)" class="backButton">
          <svg-icon icon-class="backButton" style="width:12px;height:20px;"></svg-icon>
        </div>
      </template>
      <template #title>
        <div style="height: 40px">
          <div>{{ $route.query.symbol }}</div>
          <div style="font-size: 10px;color:#919bad;height: 14px;display: flex;align-items: center"
               v-if="priceData[$route.query.symbol]">
            {{ timeChange(priceData[$route.query.symbol].tm) }}
          </div>

        </div>
      </template>

      <template #right>

        <div @click="$store.state.shareShow=true">
          <svg-icon icon-class="detailShare" style="width:20px;height:18px;"></svg-icon>
        </div>
      </template>


    </van-nav-bar>

    <share></share>


    <van-popup v-model="showDetail" closeable v-if="detailData.length>0">
      <div class="detailFrame">

        <div class="detailTitle">

          <div>品种详情</div>
        </div>

        <div v-for="(data,index) in detailData" class="detailLine"
             :style="index%2===0?'backgroundColor:#f2f2f2':'backgroundColor:#f4f8fb'">
          <div class="detailLineTitle van-hairline--right">
            {{ data.title }}
          </div>
          <div class="detailLineValue">


            <div v-if="index!==3">
              {{ data.value }}
            </div>

            <div v-if="index ===3">


              <div v-if="data.value">
                周日: 闭市<br/>
                周一: 06:00-次日05:00<br/>
                周二: 06:00-次日05:00<br/>
                周三: 06:00-次日05:00<br/>
                周四: 06:00-次日05:00<br/>
                周五: 06:00-次日05:00<br/>
                周六: 闭市
              </div>
              <div v-if="!data.value">
                上午: 9：00-10：15，10：30-11：30<br/>
                下午: 13：30-15：00<br/>
                晚上: 21：00-23：00（夜盘）


              </div>

            </div>


          </div>
        </div>


      </div>
    </van-popup>


    <div style="padding-top: 46px;">


      <div class="symbolDataBox">

        <div>
          <div class="firstLine">
            <div class="symbolPrice" :style="'color:'+(priceData[$route.query.symbol].profit<0?'#41bf9b':'#f84242')"
                 v-if="priceData[$route.query.symbol]">
              {{ priceData[$route.query.symbol].strike }}
            </div>
            <div class="profitBox">
              <div class="inProfitBox">
                <div :style="'color:'+(priceData[$route.query.symbol].profit<0?'#41bf9b':'#f84242')"
                     v-if="priceData[$route.query.symbol]">
                  {{ priceData[$route.query.symbol].profit }}
                </div>
                <div :style="'color:'+(priceData[$route.query.symbol].profit<0?'#41bf9b':'#f84242')"
                     v-if="priceData[$route.query.symbol]">
                  {{ priceData[$route.query.symbol].rateProfit }}%
                </div>
              </div>
            </div>


            <div
                style="position: absolute;right: 16px;top:11px"
                @click="openDetail">

              <svg-icon icon-class="symbolInfoButton" style="width: 16px;height: 16px"></svg-icon>

            </div>


          </div>


          <div :style="'overflow-y: hidden;'+(showMore?'height:100px':'height:50px')">
            <div class="sonFrame" v-if="symbolData.length>0">
              <div class="sonBox" v-for="(item,index) in symbolData" style="margin-top: 4px;margin-bottom: 4px">
                <div class="inSonBox" :style="index%3===0?'float:left;':index%3===1?'margin: 0 auto;':'float:right;'">
                  <div>{{ item.title }}</div>
                  <div style="margin-left: auto" v-if="priceData[$route.query.symbol]">
                    {{
                      ((index === 2 || index === 5) && symbolData.length === 6) ? index === 2 ? priceData[$route.query.symbol].bid : priceData[$route.query.symbol].ask : item.value < (Math.pow(10, 8)) ? item.value < (Math.pow(10, 6)) ? item.value : (Math.round(item.value / (Math.pow(10, 4)))) + '万' : (Math.round(item.value / (Math.pow(10, 8)))) + '亿'
                    }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="showMoreLine" v-if="symbolData && symbolData.length>6" @click="showMore=!showMore">


            <svg-icon :icon-class="showMore?'ArrowUp':'ArrowDown'" style="width: 7px;height: 4px"></svg-icon>

          </div>

        </div>

      </div>


      <div class="TVChartContainer" :id="containerId" style="height: 400px"/>


      <van-tabs style="width: 100%" color="#1875f8" line-width="15px" line-height="3px" title-active-color="#1875f8"
                offset-top="46px" duration="0.5" v-model="active" animated sticky swipeable>

        <van-tab title="相关文章" :title-style="'font-size:15px;'+(active===0?'font-weight:border':'')">


          <!---->
          <div v-if="infoList.length===0 && finished">
            <van-empty description="暂无相关文章"/>
          </div>

          <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
            <van-list v-model="loading" :finished="finished"
                      :finished-text="!(infoList.length===0 && finished)?'没有更多了':''"
                      @load="onLoad"
                      style="background-color: #f4f6fa">


              <div class="information">
                <div v-for="(value,index) in infoList">
                  <div class="infoBox van-hairline--bottom" @click="$infoDetailJump(value.id)">


                    <div class="boxLeft">
                      <div class="leftIn">

                        <div class="infoTitle"><span class="infoTitleText">{{
                            value.title.slice(0, 30)
                          }}</span>
                        </div>
                        <div class="summary"><span class="summaryText">{{ $summary(value.summary) }}</span>
                        </div>
                        <div class="infoBottom">
                          <div class="symbolTypeBox">
                            <div class="symbolTypeBoxIn"></div>
                            <div class="symbolType">{{ value.symbol_type_name }}</div>
                          </div>
                          <span class="author">{{ value.author_CN }}</span>
                          <span class="dateShowInfo">{{ $dateChange(value.release_time_check) }}</span>
                        </div>

                      </div>
                    </div>
                    <div class="boxRight">

                      <div class="rightIn">

                        <img :src="value.cover" style="height: 100%;width: 100%;border-radius: 4px;">

                      </div>
                    </div>
                  </div>


                </div>
              </div>


            </van-list>
          </van-pull-refresh>


          <!---->


        </van-tab>

        <van-tab title="数据统计" :title-style="'font-size:15px;'+(active===1?'font-weight:border':'')">
          <div class="statFrame">
            <div style="width: 50%;">
              <div v-for="(item,index) in statList[0]" class="statBox"
                   style="padding-right: 8px;">
                <div>{{ item.title }}</div>
                <div v-if="index===0" class="statValue">{{ item.value }}</div>
                <div v-if="index!==0" class="statValue" :style="item.value > 0 ?'color:#f84242':'color:#2eba94'">
                  {{ item.value > 0 ? '+' + item.value : item.value }}
                </div>
              </div>
            </div>
            <div style="width: 50%;">
              <div v-for="(item,index) in statList[1]" class="statBox"
                   style="padding-left: 8px;">
                <div>{{ item.title }}</div>
                <div v-if="index===0" class="statValue">{{ item.value }}</div>
                <div v-if="index!==0" class="statValue" :style="item.value > 0 ?'color:#f84242':'color:#2eba94'">
                  {{ item.value > 0 ? '+' + item.value : item.value }}%
                </div>
              </div>
            </div>

          </div>


        </van-tab>


      </van-tabs>


    </div>
  </div>
</template>

<script>

import {widget} from '../../../public/charting_library';
import Share from "@/components/public/share";

function getLanguageFromURL() {
  const regex = new RegExp('[\\?&]lang=([^&#]*)');
  const results = regex.exec(window.location.search);
  return results === null ? null : decodeURIComponent(results[1].replace(/\+/g, ' '));
}


export default {

  name: 'chart',
  components: {Share},
  data() {
    return {
      list: [],
      end: 0,
      priceData: {},
      symbolData: [],
      showMore: false,
      showDetail: false,
      detailData: [],
      detailList: [
        {title: '交易品种', valueName: 'symbolName'},
        {title: '合约量', valueName: 'contractSize'},
        {title: '最小变动价位', valueName: 'priceStep'},
        {title: '交易时间', valueName: ''},
        {title: '交易量步长', valueName: 'minVolume'},
        {title: '最大交易量', valueName: 'maxVolume'},
        {title: '开始交割时间', valueName: 'startDeliverDate'},
        {title: '结束交割时间', valueName: 'endDeliverDate'},
        {title: '交割代码', valueName: 'symbol'}
      ],
      active: 0,
      query: {
        information_type: 2,//类型：文章
        keyWorld: this.$route.query.symbol,
        page_size: 10,
      },
      infoList: [],
      statList: [[], []],

      refreshing: false,
      loading: false,
      finished: false,


    }
  },
  methods: {
    datafeeds(that) {
      return {
        onReady(callback) {
          let configurationData = {
            exchanges: [],
            symbols_types: [],
            supports_time: true,
            supported_resolutions: [1, 15, 30, 60, 240, "D", "W", "M"],
            supports_marks: false,
            supports_timescale_marks: false,
            pricescale: 100,


          }
          callback(configurationData)

        },
        resolveSymbol(symbolName, onSymbolResolvedCallback, onResolveErrorCallback) {
          let data = {
            name: symbolName,
            has_intraday: true, // 分钟数据
            has_daily: true, // 日k线数据
            has_weekly_and_monthly: true, // 月，周数据
          };

          if (!this.onSymbolResolvedCallback) {
            this.onSymbolResolvedCallback = onSymbolResolvedCallback;
          }

          setTimeout(function () {
            onSymbolResolvedCallback(data);
          }, 0);

        },

        getBars(symbolInfo, resolution, from, to, onHistoryCallback, onErrorCallback, firstDataRequest) {
          this.firstDataRequest = firstDataRequest;
          this.onHistoryCallback = onHistoryCallback;
          this.resolution = resolution;
          // 封装函数渲染视图
          this.history(from * 1000, to * 1000, resolution, firstDataRequest, onHistoryCallback);

        },
        async history(from, to, resolution, firstDataRequest, cb) {
          let bar = [];
          let type = that.$kLineType(resolution)
          let end = firstDataRequest ? 0 : that.end


          that.$post(that.$store.state.marketApiUrl + '/api/quote/kline', {
            type,
            symbol: that.$route.query.symbol,
            end
          }).then(res => {

            if (res.status === '0') {
              if (res.data.length > 1) {
                that.end = res.data[0].ctm

                res.data.map(item => {
                  let barValue = {};
                  // 时间戳
                  barValue.time = Number(item.ctm) * 1000;
                  // 开
                  barValue.open = Number(item.open);
                  // 高
                  barValue.high = Number(item.high);
                  // 低
                  barValue.low = Number(item.low);
                  // 收
                  barValue.close = Number(item.close);
                  // 量
                  barValue.volume = Number(item.vol);

                  bar.push(barValue);
                })
                cb(bar, {
                  noData: false
                });
              } else {
                cb([], {
                  noData: true
                })
              }

              this.bar = bar

            } else {
              cb([], {
                noData: true
              });
            }

          }).catch(err => {
            console.log(err)
          })
          this.bar = bar;
        },


        subscribeBars(symbolInfo, resolution, onRealtimeCallback, listenerGuid, onResetCacheNeededCallback) {
          let priceData = {}


          let type = that.$kLineType(resolution)
          that.$post(that.$store.state.marketApiUrl + '/api/quote/kline', {
            type,
            symbol: that.$route.query.symbol,
          }).then(res => {
            if (res.data && res.data.length > 1) {
              let item = res


              let time = item.data[item.data.length - 1].ctm * 1000


              let high = item.data[item.data.length - 1].high
              let low = item.data[item.data.length - 1].low
              let interval = setInterval(() => {
                if (that.$route.path.indexOf("/chart") === -1) {
                  clearInterval(interval)
                }
                priceData = this.getFreshPriceData()

                if (priceData[that.$route.query.symbol]) {
                  if (priceData[that.$route.query.symbol].tm >= time + type * 60 * 1000) {
                    that.$post(that.$store.state.marketApiUrl + '/api/quote/kline', {
                      type,
                      symbol: that.$route.query.symbol,
                    }).then(res => {
                      if (res.data && res.data.length > 1) {
                        item = res
                        if (item.data[item.data.length - 1].ctm * 1000 > time) {

                          let newKLine = {
                            time,
                            high: item.data[item.data.length - 2].high,
                            low: item.data[item.data.length - 2].low,
                            open: item.data[item.data.length - 2].open,
                            close: item.data[item.data.length - 2].close,
                            volume: item.data[item.data.length - 2].volume,
                          }
                          onRealtimeCallback(newKLine)

                          time = item.data[item.data.length - 1].ctm * 1000
                          high = item.data[item.data.length - 1].high > priceData[that.$route.query.symbol].strike ? item.data[item.data.length - 1].high : priceData[that.$route.query.symbol].strike
                          low = item.data[item.data.length - 1].low < priceData[that.$route.query.symbol].strike ? item.data[item.data.length - 1].low : priceData[that.$route.query.symbol].strike
                        }
                      }


                    }).catch(err => {
                      console.log(err)
                    })
                  }
                  if (priceData[that.$route.query.symbol].strike > high) {
                    high = priceData[that.$route.query.symbol].strike
                  }
                  if (priceData[that.$route.query.symbol].strike < low) {
                    low = priceData[that.$route.query.symbol].strike
                  }
                  let newKLine = {
                    time,
                    high,
                    low,
                    open: item.data[item.data.length - 1].open,
                    close: priceData[that.$route.query.symbol].strike,
                    volume: item.data[item.data.length - 1].volume,
                  }

                  onRealtimeCallback(newKLine)
                }


              }, 500)


            }


          }).catch(err => {
            console.log(err)
          })


        },

        getFreshPriceData() {
          if (localStorage.newPriceKey) {
            return JSON.parse(localStorage.newPriceKey)

          }
        },

        unsubscribeBars(subscriberUID) {

        }

      }
    },


    createFeed() {

    },
    getFreshPrice() {
      if (localStorage.newPriceKey) {
        this.priceData = JSON.parse(localStorage.newPriceKey)
        this.$forceUpdate()
      }
    },
    getSymbolData() {
      this.$get(this.$store.state.marketApiUrl + '/api/quote/priceInfo', {symbol: this.$route.query.symbol}).then(res => {
        for (let i = 0; i < res.data.titles.length; i++) {
          this.symbolData[i] = {}
          this.symbolData[i].title = res.data.titles[i]
          this.symbolData[i].value = res.data.values[i]
        }


      }).catch(err => {
        console.log(err)
      })
    },
    timeChange(value) {
      return this.$format(value, "MM/dd") + ' ' + this.$format(value, "HH:mm:ss")
    },
    timeChangeDetail(value) {
      return value === 0 ? '-' : this.$format(value, "yyyy-MM-dd")
    },
    openDetail() {
      if (this.showDetail === false) {
        if (this.detailData.length === 0) {
          this.$get(this.$store.state.marketApiUrl + '/api/symbol/symbolsDetail', {symbol: this.$route.query.symbol}).then(res => {
            if (res.data) {
              for (let i = 0; i < 6; i++) {
                if (i !== 3) {
                  let value = res.data[this.detailList[i].valueName]
                  if (!isNaN(value)) {
                    value = value < 0.1 ? value : value.toFixed(1)
                  }

                  this.detailData[i] = {title: this.detailList[i].title, value}
                } else {
                  this.detailData[i] = {title: this.detailList[i].title}
                }
              }

              if (res.data.endDeliverDate === 0) {
                this.detailData[3].value = true
              } else {
                this.detailData[3].value = false


                this.detailData[6] = {
                  title: this.detailList[6].title,
                  value: this.timeChangeDetail(res.data[this.detailList[6].valueName] * 1000)
                }
                this.detailData[7] = {
                  title: this.detailList[7].title,
                  value: this.timeChangeDetail(res.data[this.detailList[7].valueName] * 1000)
                }
                this.detailData[8] = {title: this.detailList[8].title, value: res.data[this.detailList[8].valueName]}
              }


            }
          }).catch(err => {
            console.log(err)
          })
        }
      }
      this.showDetail = true
    },

    onLoad() {
      if (this.refreshing) {
        this.infoList = []
        this.refreshing = false;
      }


      let query = this.$encrypt(this.$genQuery(this.query))
      this.$get(this.$store.state.apiUrl + '/information/search', {qdata: query}).then(res => {


        if (res.data.list.length > 0) {
          res.data.list.forEach(item => {
            this.infoList.push(item)
          })

        }

        this.loading = false;
        this.$forceUpdate();
        if (res.data.list.length === 0 || res.data.list.length % 10 !== 0) {
          this.finished = true;
        }


      }).catch(err => {
        console.log(err)
      })
    },

    onRefresh() {
      // 清空列表数据
      this.finished = false;
      this.query.last_id = 0;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.onLoad();


    },

    getStat() {
      this.$post(this.$store.state.marketApiUrl + '/api/quote/stat', {symbol: this.$route.query.symbol}).then(res => {
        if (res.data) {
          this.statList[0][0] = {title: '52周高位', value: res.data.week52High}
          this.statList[0][1] = {title: '1周+/-', value: res.data.week}
          this.statList[0][2] = {title: '1月+/-', value: res.data.month}
          this.statList[0][3] = {title: '3月+/-', value: res.data.month3}
          this.statList[0][4] = {title: '6月+/-', value: res.data.month6}
          this.statList[0][5] = {title: '12月+/-', value: res.data.month12}
          this.statList[0][5] = {title: '1年+/-', value: res.data.year}

          this.statList[1][0] = {title: '52周低位', value: res.data.week52Low}
          this.statList[1][1] = {title: '1周%+/-', value: res.data.weekRate}
          this.statList[1][2] = {title: '1月%+/-', value: res.data.monthRate}
          this.statList[1][3] = {title: '3月%+/-', value: res.data.month3Rate}
          this.statList[1][4] = {title: '6月%+/-', value: res.data.month6Rate}
          this.statList[1][5] = {title: '12月%+/-', value: res.data.month12Rate}
          this.statList[1][5] = {title: '1年%+/-', value: res.data.yearRate}
        }else {
          this.statList[0][0] = {title: '52周高位', value: '--'}
          this.statList[0][1] = {title: '1周+/-', value: '--'}
          this.statList[0][2] = {title: '1月+/-', value: '--'}
          this.statList[0][3] = {title: '3月+/-', value: '--'}
          this.statList[0][4] = {title: '6月+/-', value: '--'}
          this.statList[0][5] = {title: '12月+/-', value: '--'}
          this.statList[0][5] = {title: '1年+/-', value: '--'}

          this.statList[1][0] = {title: '52周低位', value: '--'}
          this.statList[1][1] = {title: '1周%+/-', value: '--'}
          this.statList[1][2] = {title: '1月%+/-', value: '--'}
          this.statList[1][3] = {title: '3月%+/-', value: '--'}
          this.statList[1][4] = {title: '6月%+/-', value: '--'}
          this.statList[1][5] = {title: '12月%+/-', value: '--'}
          this.statList[1][5] = {title: '1年%+/-', value: '--'}
        }


      }).catch(err => {
        console.log(err)
      })
    }


  },
  props: {
    symbol: {
      default: 'A',
      type: String,
    },
    interval: {
      default: 'D',
      type: String,
    },
    containerId: {
      default: 'tv_chart_container',
      type: String,
    },
    datafeedUrl: {
      default: 'https://demo_feed.tradingview.com',
      type: String,
    },
    libraryPath: {
      default: '/charting_library/',
      type: String,
    },
    chartsStorageUrl: {
      default: 'https://saveload.tradingview.com',
      type: String,
    },
    chartsStorageApiVersion: {
      default: '1.1',
      type: String,
    },
    clientId: {
      default: 'tradingview.com',
      type: String,
    },
    userId: {
      default: 'public_user_id',
      type: String,
    },
    fullscreen: {
      default: false,
      type: Boolean,
    },
    autosize: {
      default: true,
      type: Boolean,
    },
    studiesOverrides: {
      type: Object,
    }
  },
  tvWidget: null,
  mounted() {
    this.connectWs([this.$route.query.symbol])
    this.getSymbolData()
    const widgetOptions = {
      symbol: this.$route.query.symbol,
      datafeed: this.datafeeds(this),
      interval: this.interval,
      container_id: this.containerId,
      library_path: this.libraryPath,
      locale: "zh",
      timezone: "Asia/Shanghai",

      minmov: 1,
      pricecale: 100,
      minmove2: 0,


      overrides: {
        'paneProperties.topMargin': 20,
        'paneProperties.legendProperties.showLegend': false,//默认显示线信息
        "mainSeriesProperties.candleStyle.upColor": "#fff",
        "mainSeriesProperties.candleStyle.downColor": "#2eba94",
        "mainSeriesProperties.candleStyle.borderColor": "#f84242",
        "mainSeriesProperties.candleStyle.borderUpColor": "#f84242",
        "mainSeriesProperties.candleStyle.borderDownColor": "#2eba94",
        "mainSeriesProperties.candleStyle.wickColor": "#737375",
        "mainSeriesProperties.candleStyle.wickUpColor": "#f84242",
        "mainSeriesProperties.candleStyle.wickDownColor": "#2eba94",


      },
      studies_overrides: {
        "volume.volume.color.0": "#2eba94",
        "volume.volume.color.1": "#f84242",
        "volume.volume.transparency": 75,
      },

      disabled_features: [
        'use_localstorage_for_settings',//使用本地存储进行设置
        'left_toolbar',//左侧工具栏
        'adaptive_logo',//logo
        'timeframes_toolbar',//时间工具栏
        'header_widget_dom_node',//标题小部件节点
        'header_symbol_search',//种类搜索栏
        'source_selection_markers',//种类选择栏
        'header_resolutions',//周期选择
        'header_chart_type',//图标类型选择
        'header_saveload',
        'border_around_the_chart',
        'remove_library_container_border',
        'header_screenshot',
        'snapshot_trading_drawings',
        'header_settings',
        // 'header_interval_dialog_button',
        //'show_interval_dialog_on_key_press'
        'header_fullscreen_button',
        'symbol_info',
        'pane_context_menu',
        // 'control_bar',
        'property_pages',
        'symbol_search_hot_key',
        'study_dialog_search_control',
        'main_series_scale_menu',
        "header_chart_type", //隐藏k线样式选择
        "header_indicators", //隐藏指标按钮
        "header_undo_redo", //隐藏撤销重做按钮
        "header_compare", //隐藏比较/增加商品按钮
        "edit_buttons_in_legend",
        "legend_context_menu",
        "display_market_status",
        // "volume_force_overlay",
        // "pricescale_currency",
        "show_chart_property_page",
        "popup_hints",
        "chart_property_page_style",
        "timeframes_toolbar",
        "object_tree_legend_mode",
      ],
      // enabled_features: ['study_templates'],


      charts_storage_url: this.chartsStorageUrl,
      charts_storage_api_version: this.chartsStorageApiVersion,
      client_id: this.clientId,
      user_id: this.userId,
      fullscreen: this.fullscreen,
      autosize: this.autosize,

      // studies_overrides: this.studiesOverrides,
    };

    const tvWidget = new widget(widgetOptions);
    this.tvWidget = tvWidget;

    tvWidget.onChartReady(() => {
      this.tvWidget.chart().createStudy('Moving Average', false, false, [5], null, {'Plot.color': 'rgb(150, 95, 196)'});
      this.tvWidget.chart().createStudy('Moving Average', false, false, [10], null, {'Plot.color': 'rgb(116,149,187)'});
      this.tvWidget.chart().createStudy('Moving Average', false, false, [20], null, {'plot.color': 'rgb(58,113,74)'});
      this.tvWidget.chart().createStudy('Moving Average', false, false, [30], null, {'plot.color': 'rgb(118,32,99)'});
      this.tvWidget.chart().createStudy('MACD');


      tvWidget.headerReady().then(() => {
        const minute1 = tvWidget.createButton()
        minute1.innerHTML = '1分钟';
        minute1.addEventListener('click', () => {
          this.tvWidget.activeChart().setResolution('1');
        })
        const minute15 = tvWidget.createButton()
        minute15.innerHTML = '15分钟';
        minute15.addEventListener('click', () => {
          this.tvWidget.activeChart().setResolution('15');
        })
        const minute30 = tvWidget.createButton()
        minute30.innerHTML = '30分钟';
        minute30.addEventListener('click', () => {
          this.tvWidget.activeChart().setResolution('30');
        })
        const hour1 = tvWidget.createButton()
        hour1.innerHTML = '1小时';
        hour1.addEventListener('click', () => {
          this.tvWidget.activeChart().setResolution('60');
        })
        const hour4 = tvWidget.createButton()
        hour4.innerHTML = '4小时';
        hour4.addEventListener('click', () => {
          this.tvWidget.activeChart().setResolution('240');
        })
        const day = tvWidget.createButton()
        day.innerHTML = '日K';
        day.addEventListener('click', () => {
          this.tvWidget.activeChart().setResolution('D');
        })
        const week = tvWidget.createButton()
        week.innerHTML = '周K';
        week.addEventListener('click', () => {
          this.tvWidget.activeChart().setResolution('W');
        })
        const month = tvWidget.createButton()
        month.innerHTML = '月K';
        month.addEventListener('click', () => {
          this.tvWidget.activeChart().setResolution('M');
        })


      });
    });

    setInterval(() => {
      this.getFreshPrice()
    }, 500)

    this.getStat()
  },
  destroyed() {
    if (this.tvWidget !== null) {
      this.tvWidget.remove();
      this.tvWidget = null;
    }
  }

}
</script>

<style lang="scss" scoped>
.TVChartContainer {
  height: calc(100vh - 80px);
}

.symbolDataBox {
  position: relative;

  padding: 0 16px;
}

.firstLine {
  display: flex;
  width: 100%;
  height: 38px;
}

.symbolPrice {
  font-weight: bolder;
  font-size: 32px;

}

.profitBox {
  height: 38px;
  font-size: 11px;
  left: 120px;
  display: flex;
  align-items: center;
  margin-left: 5px;
}

.inProfitBox {
  text-align: left;
}

.sonFrame {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.sonBox {
  font-size: 12px;
  width: 30%;
  height: 17px;


}

.inSonBox {
  display: flex;
  width: 60%;
  min-width: 103px;

}

.showMoreLine {
  height: 20px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.detailFrame {
  width: 350px;


}

.detailTitle {
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
}


.detailLine {
  min-height: 46px;
  width: 100%;
  display: flex;
  font-size: 12px;
}

.detailLineTitle {
  width: 30%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.detailLineValue {
  width: 70%;
  margin: 10px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: left;
}

.statFrame {
  padding: 0 16px;
  box-sizing: border-box;
  display: flex;
  font-size: 12px;
}

.statBox {
  display: flex;
  box-sizing: border-box;
  align-items: center;
  margin: 7px 0;
}

.statValue {
  margin-left: auto;
}


</style>
